import { RootState } from '../../../applicationStore';
import { TimesheetLockState } from '../reducers';
import { createSelector } from '@reduxjs/toolkit';

export const getTimesheetLockState = (state: RootState): TimesheetLockState =>
  state.timesheetLock;

export const getTimesheetLockLoader = createSelector(
  getTimesheetLockState,
  (state): boolean => state.loading,
);

export const getTimesheetData = createSelector(
  getTimesheetLockState,
  (state): TimesheetLockState['data'] | null => state?.data || null,
);
